export const formatAsImagePath = (item: string) =>
  item.toLowerCase().replace(/\s/g, '')
